import React from 'react';
import { Box, Typography, Avatar, Button, Divider } from '@mui/material';
import { useTranslation } from '@fanfanlo';

export const MemberDetailContent = ({ roomId, userId }: { roomId: string; userId: string }) => {
  const { t } = useTranslation('homepage/im/components/room-settings/member-detail/content');

  // TODO: 拉取成员详细信息，展示头像、昵称、ID、权限等
  // TODO: 展示操作按钮（踢出、封禁、提升权限等）

  return (
    <Box sx={{ p: 2 }}>
      <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
        <Avatar sx={{ width: 56, height: 56, mr: 2 }} />
        <Box>
          <Typography variant="h6">{t('MemberDetailContent.nickname')}</Typography>
          <Typography variant="body2" color="text.secondary">{userId}</Typography>
        </Box>
      </Box>
      <Divider sx={{ my: 2 }} />
      {/* 这里可以展示更多成员信息，如权限等级、加入时间等 */}
      <Box sx={{ mb: 2 }}>
        <Typography variant="body2" color="text.secondary">{t('MemberDetailContent.role')}: ...</Typography>
      </Box>
      <Divider sx={{ my: 2 }} />
      {/* 操作按钮区 */}
      <Box sx={{ display: 'flex', gap: 2 }}>
        <Button variant="contained" color="error">{t('MemberDetailContent.kick')}</Button>
        <Button variant="outlined" color="error">{t('MemberDetailContent.ban')}</Button>
        {/* 其它操作按钮可按需添加 */}
      </Box>
    </Box>
  );
};
